module.exports = require('./helpers/bundle-url').getBundleURL('h0ehp') + "ifigenia.f683616b.png";